/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Train, Clock } from 'lucide-react'

import { useFilters, useGeneral } from '@contexts'
import { useGetConfigurationsData, useLogout } from '@hooks'

import { StyledMenu } from './components'
import { PATHS } from '../../../types'

const SupplierMenu: () => JSX.Element = () => {
  const { pathname } = useLocation()
  const { logout } = useLogout()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { setTicketToSearch } = useGeneral()
  const { resetFilters } = useFilters()

  const { dataConfiguration } = useGetConfigurationsData()
  let tokenExpirationSeconds: number

  const clearFiltersOnComponentChange = () => {
    setTicketToSearch(undefined)
    resetFilters()
  }

  // TODO: pendiente de implementación
  // const handleClickPrevious = () => {
  //   navigate('/dashboard/suppliers/previous')
  //   clearFiltersOnComponentChange()
  // }
  const handleClickHistoric = () => {
    navigate('/dashboard/suppliers/historic')
    clearFiltersOnComponentChange()
  }

  const handleClickBlocktrains = () => {
    navigate('/dashboard/suppliers/blocktrains')
    clearFiltersOnComponentChange()
  }

  const items = useMemo(
    () => [
      {
        key: PATHS.SUPPLIER.BLOCKTRAINS,
        onClick: handleClickBlocktrains,
        icon: <Train />,
        label: t('blocktrains'),
      },
      {
        key: PATHS.SUPPLIER.HISTORIC,
        onClick: handleClickHistoric,
        icon: <Clock />,
        label: t('historic'),
      },
    ],
    [pathname, t],
  )

  useEffect(() => {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < dataConfiguration?.configurationProperties.length; i++) {
      if (dataConfiguration?.configurationProperties[i].key === 'TOKEN_EXPIRATION_SECONDS') {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        tokenExpirationSeconds = dataConfiguration?.configurationProperties[i].value
        break
      }
    }

    setTimeout(() => {
      if (tokenExpirationSeconds !== undefined) {
        logout()
      }
    }, (tokenExpirationSeconds - 1) * 1000)
  }, [dataConfiguration])

  return <StyledMenu selectedKeys={[pathname]} mode="inline" items={items} />
}

export { SupplierMenu }
